// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"263":"recipes","270":"cms","445":"start","644":"account","945":"dashboard"}[chunkId] || chunkId) + "." + {"160":"63fa664c","263":"f95d90c8","270":"2d72c1e8","438":"605db2b1","445":"9a5639b1","644":"9e51d07a","945":"e4319372"}[chunkId] + ".css";
};